// English dictionary — keys are the original user-visible strings
export const en: Record<string, string> = {
  // Brand
  "ChinaCare+": "ChinaCare+",
  "Medical Care in China": "Medical Care in China",

  // Header menu
  "Medical Services": "Medical Services",
  "Hospitals": "Hospitals",
  "Doctors": "Doctors",
  "Book a Service": "Book a Service",
  "Travel Assistance": "Travel Assistance",
  "Help Center": "Help Center",

  // Languages
  "English": "English",
  "简体中文": "简体中文",
  "繁體中文": "繁體中文",
  "日本語": "日本語",
  "한국어": "한국어",
  "Français": "Français",
  "Deutsch": "Deutsch",
  "Español": "Español",

  // BottomNav
  "Home": "Home",
  "Bookings": "Bookings",
  "Concierge": "Concierge",
  "Me": "Me",

  // Banner
  "Trusted": "Trusted",
  "Medical Care": "Medical Care",
  "in China": "in China",
  "Checkup · Treatment · Surgery · Recovery": "Checkup · Treatment · Surgery · Recovery",

  // SearchBar
  "Search hospitals, treatments or services": "Search hospitals, treatments or services",

  // Service categories
  "Health Checkup": "Health Checkup",
  "Medical Treatment": "Medical Treatment",
  "Surgery Services": "Surgery Services",
  "Recovery & Rehabilitation": "Recovery & Rehabilitation",

  // Concierge banner
  "Your Medical Concierge in China": "Your Medical Concierge in China",
  "From consultation to recovery, we are with you every step.": "From consultation to recovery, we are with you every step.",
  "Chat with Concierge": "Chat with Concierge",

  // Hospitals section (home)
  "Recommended Hospitals": "Recommended Hospitals",
  "View All": "View All",
  "Top Hospital": "Top Hospital",
  "Remove from favorites": "Remove from favorites",
  "Add to favorites": "Add to favorites",
  "reviews": "reviews",

  // How It Works
  "How It Works": "How It Works",
  "Submit Your Request": "Submit Your Request",
  "Medical Assessment": "Medical Assessment",
  "Come to China": "Come to China",
  "Treatment & Follow-up": "Treatment & Follow-up",

  // Why Choose China
  "Why Choose China?": "Why Choose China?",
  "World-class Hospitals": "World-class Hospitals",
  "Experienced Specialists": "Experienced Specialists",
  "Advanced Medical Technology": "Advanced Medical Technology",
  "High-Value Care": "High-Value Care",

  // Hospitals page
  "Top-ranked medical centres across China": "Top-ranked medical centres across China",
  "Search hospitals or specialties...": "Search hospitals or specialties...",
  "City": "City",
  "Specialty": "Specialty",
  "No hospitals found": "No hospitals found",
  "Try another city, specialty or keyword.": "Try another city, specialty or keyword.",

  // Doctors page
  "Our Doctors": "Our Doctors",
  "English-speaking specialists vetted for international care": "English-speaking specialists vetted for international care",
  "Search doctors or specialties...": "Search doctors or specialties...",
  "No doctors found": "No doctors found",
  "Try a different name or specialty.": "Try a different name or specialty.",
  "yrs exp": "yrs exp",

  // Services page
  "Specialist care across checkup, treatment, surgery and recovery": "Specialist care across checkup, treatment, surgery and recovery",
  "Search services...": "Search services...",
  "All": "All",
  "No services found": "No services found",
  "Try a different keyword or choose another care category.": "Try a different keyword or choose another care category.",
  "Request This Service": "Request This Service",

  // Book page
  "Submit your medical service request": "Submit your medical service request",
  "Full Name *": "Full Name *",
  "Enter your full name": "Enter your full name",
  "Email Address *": "Email Address *",
  "Country / Region *": "Country / Region *",
  "Your country": "Your country",
  "Preferred City": "Preferred City",
  "Any city": "Any city",
  "Medical Service *": "Medical Service *",
  "Select a service": "Select a service",
  "Preferred Date *": "Preferred Date *",
  "Preferred Language": "Preferred Language",
  "Contact Preference": "Contact Preference",
  "Medical Records (Optional)": "Medical Records (Optional)",
  "Tap to upload your records": "Tap to upload your records",
  "Additional Requirements": "Additional Requirements",
  "Describe your medical needs, conditions, or special requirements...": "Describe your medical needs, conditions, or special requirements...",
  "Records can also be shared securely with your concierge after booking.": "Records can also be shared securely with your concierge after booking.",
  "Submit Request": "Submit Request",
  "Submitting...": "Submitting...",
  "Full name is required": "Full name is required",
  "Email is required": "Email is required",
  "Invalid email format": "Invalid email format",
  "Country is required": "Country is required",
  "Please select a service": "Please select a service",
  "Preferred date is required": "Preferred date is required",
  "Request Submitted": "Request Submitted",
  "Your booking reference:": "Your booking reference:",
  "View My Bookings": "View My Bookings",
  "Back to Home": "Back to Home",

  // Booking status note
  "This is a service request, not a confirmed appointment. Our team will review your request and coordinate with the hospital. You will receive a status update within 1–3 business days.":
    "This is a service request, not a confirmed appointment. Our team will review your request and coordinate with the hospital. You will receive a status update within 1–3 business days.",

  // Languages dropdown (book form)
  "Chinese": "Chinese",
  "Japanese": "Japanese",
  "Korean": "Korean",
  "Spanish": "Spanish",
  "French": "French",
  "German": "German",
  "Russian": "Russian",
  "Arabic": "Arabic",
  "Other": "Other",

  // Contact prefs
  "Email": "Email",
  "Phone": "Phone",
  "WhatsApp": "WhatsApp",
  "WeChat": "WeChat",

  // Booking status labels
  "Pending": "Pending",
  "Under Review": "Under Review",
  "Coordinating": "Coordinating",
  "Confirmed": "Confirmed",
  "Completed": "Completed",
  "Cancelled": "Cancelled",

  // Booking status notes
  "Your request is being reviewed by our medical team.": "Your request is being reviewed by our medical team.",
  "We are coordinating with the hospital for your appointment.": "We are coordinating with the hospital for your appointment.",
  "Your treatment has been completed. Follow-up scheduled.": "Your treatment has been completed. Follow-up scheduled.",
  "Your request has been submitted and is awaiting review.": "Your request has been submitted and is awaiting review.",

  // Bookings page
  "My Bookings": "My Bookings",
  "Track your service requests": "Track your service requests",
  "No bookings yet": "No bookings yet",
  "Submit a request and our team will coordinate your care.": "Submit a request and our team will coordinate your care.",
  "Submitted": "Submitted",

  // Concierge page
  "Medical Concierge": "Medical Concierge",
  "Welcome to ChinaCare+ Medical Concierge! How can I help you today?": "Welcome to ChinaCare+ Medical Concierge! How can I help you today?",
  "Online · Typically replies in 1 hour": "Online · Typically replies in 1 hour",
  "How do I book a service?": "How do I book a service?",
  "What documents do I need?": "What documents do I need?",
  "How long does the process take?": "How long does the process take?",
  "Is my data secure?": "Is my data secure?",
  "Thank you for your message. A concierge specialist will respond within 1 business hour. For urgent matters, please call +86-400-123-4567.":
    "Thank you for your message. A concierge specialist will respond within 1 business hour. For urgent matters, please call +86-400-123-4567.",
  "Type your question...": "Type your question...",
  "Message your concierge": "Message your concierge",
  "Send message": "Send message",
  "Concierge responses are informational and do not replace medical advice.": "Concierge responses are informational and do not replace medical advice.",

  // Me page
  "My Profile": "My Profile",
  "Your account and care services": "Your account and care services",
  "Sign In": "Sign In",
  "Access your profile and bookings": "Access your profile and bookings",
  "Account Settings": "Account Settings",
  "Coming soon": "Coming soon",
  "Sign Out": "Sign Out",
  "Password": "Password",
  "Enter password": "Enter password",
  "Member since": "Member since",
  "ChinaCare+ coordinates medical services and does not provide diagnosis or treatment directly.": "ChinaCare+ coordinates medical services and does not provide diagnosis or treatment directly.",

  // Help page
  "Find answers to common questions about your care journey": "Find answers to common questions about your care journey",
  "General": "General",
  "Booking": "Booking",
  "Payment": "Payment",
  "Travel": "Travel",
  "Privacy": "Privacy",
  "No FAQs in this category": "No FAQs in this category",
  "Try another topic or chat with our concierge team.": "Try another topic or chat with our concierge team.",
  "Still need help?": "Still need help?",
  "Get help from our medical coordinators": "Get help from our medical coordinators",
  "Call Us": "Call Us",
  "Policies": "Policies",
  "Cancellation Policy": "Cancellation Policy",
  "Free cancellation before “Confirmed” status. After confirmation, hospital cancellation terms apply. Contact your concierge for assistance with cancellations.":
    "Free cancellation before “Confirmed” status. After confirmation, hospital cancellation terms apply. Contact your concierge for assistance with cancellations.",
  "Privacy Policy": "Privacy Policy",
  "Your medical data is encrypted and never shared without explicit consent. We comply with international data protection standards. Request data deletion at any time.":
    "Your medical data is encrypted and never shared without explicit consent. We comply with international data protection standards. Request data deletion at any time.",

  // FAQ
  "How does ChinaCare+ work?": "How does ChinaCare+ work?",
  "ChinaCare+ connects international patients with top hospitals in China. Submit your medical needs, our team coordinates with hospitals, and we guide you through every step from consultation to recovery.":
    "ChinaCare+ connects international patients with top hospitals in China. Submit your medical needs, our team coordinates with hospitals, and we guide you through every step from consultation to recovery.",
  "Is ChinaCare+ a hospital?": "Is ChinaCare+ a hospital?",
  "No. ChinaCare+ is a medical consultation and service coordination platform. We do not provide medical diagnosis, prescribe medication, or deliver treatment directly. We connect you with accredited hospitals and specialists.":
    "No. ChinaCare+ is a medical consultation and service coordination platform. We do not provide medical diagnosis, prescribe medication, or deliver treatment directly. We connect you with accredited hospitals and specialists.",
  "How long does the booking process take?": "How long does the booking process take?",
  "Initial review takes 1–3 business days. Hospital coordination typically takes 3–7 business days. Complex cases may require additional time for multidisciplinary review.":
    "Initial review takes 1–3 business days. Hospital coordination typically takes 3–7 business days. Complex cases may require additional time for multidisciplinary review.",
  "Can I cancel my booking?": "Can I cancel my booking?",
  "You can cancel your request before it reaches 'Confirmed' status at no charge. After confirmation, cancellation policies depend on the hospital's terms. Contact your concierge for assistance.":
    "You can cancel your request before it reaches 'Confirmed' status at no charge. After confirmation, cancellation policies depend on the hospital's terms. Contact your concierge for assistance.",
  "How do I pay for medical services?": "How do I pay for medical services?",
  "Medical service fees are paid directly to the hospital. ChinaCare+ service fees are billed separately. We accept international credit cards and bank transfers. Detailed pricing is provided before confirmation.":
    "Medical service fees are paid directly to the hospital. ChinaCare+ service fees are billed separately. We accept international credit cards and bank transfers. Detailed pricing is provided before confirmation.",
  "Do you help with visa applications?": "Do you help with visa applications?",
  "We provide invitation letters from partner hospitals to support your medical visa application. Visa processing is handled by the Chinese embassy or consulate in your country.":
    "We provide invitation letters from partner hospitals to support your medical visa application. Visa processing is handled by the Chinese embassy or consulate in your country.",
  "How is my medical data protected?": "How is my medical data protected?",
  "All medical information is encrypted and stored securely. We comply with international data protection standards. Your data is only shared with hospitals you explicitly authorize.":
    "All medical information is encrypted and stored securely. We comply with international data protection standards. Your data is only shared with hospitals you explicitly authorize.",
  "What is your privacy policy?": "What is your privacy policy?",
  "We collect only necessary information to coordinate your care. Data is never sold to third parties. You can request data deletion at any time. Full policy available in our Help Center.":
    "We collect only necessary information to coordinate your care. Data is never sold to third parties. You can request data deletion at any time. Full policy available in our Help Center.",

  // Travel page
  "Support services for your medical journey": "Support services for your medical journey",
  "Medical Translation": "Medical Translation",
  "Professional medical interpreters for consultations and procedures.": "Professional medical interpreters for consultations and procedures.",
  "Hospital Escort": "Hospital Escort",
  "Dedicated companion to guide you through hospital visits.": "Dedicated companion to guide you through hospital visits.",
  "Accommodation Arrangement": "Accommodation Arrangement",
  "Comfortable lodging near your treatment hospital.": "Comfortable lodging near your treatment hospital.",
  "Airport Transfer & Transport": "Airport Transfer & Transport",
  "Reliable transportation throughout your medical journey.": "Reliable transportation throughout your medical journey.",
  "Travel assistance services are coordinated by our concierge team. Availability and pricing vary by location and season.":
    "Travel assistance services are coordinated by our concierge team. Availability and pricing vary by location and season.",

  // PageHeader
  "Back": "Back",

  // Services detail page
  "Service Details": "Service Details",
  "Service not found": "Service not found",
  "This service may no longer be available.": "This service may no longer be available.",
  "What's Included": "What's Included",
  "Price Range": "Price Range",
  "Duration": "Duration",
  "Prices are estimates only. Final pricing is confirmed by the hospital after medical assessment. ChinaCare+ does not provide medical diagnosis or treatment directly.":
    "Prices are estimates only. Final pricing is confirmed by the hospital after medical assessment. ChinaCare+ does not provide medical diagnosis or treatment directly.",

  // Hospitals detail page
  "Hospital Details": "Hospital Details",
  "Hospital not found": "Hospital not found",
  "This hospital may no longer be listed.": "This hospital may no longer be listed.",
  "Accreditation": "Accreditation",
  "Departments": "Departments",
  "Hospital information is for reference only. Availability and services are subject to hospital confirmation.":
    "Hospital information is for reference only. Availability and services are subject to hospital confirmation.",
  "Request Service at This Hospital": "Request Service at This Hospital",

  // Doctors detail page
  "Doctor Details": "Doctor Details",
  "Doctor not found": "Doctor not found",
  "This profile may no longer be available.": "This profile may no longer be available.",
  "About": "About",
  "Experience": "Experience",
  "Rating": "Rating",
  "Specialties": "Specialties",
  "Languages": "Languages",
  "Doctor profiles are for reference. Availability is subject to hospital scheduling.":
    "Doctor profiles are for reference. Availability is subject to hospital scheduling.",
  "Request Appointment": "Request Appointment",

  // Concierge FAQ responses (hardcoded answers)
  "You can book by going to Medical Services, selecting a service, and clicking 'Request This Service'. Our team will review and coordinate with the hospital.":
    "You can book by going to Medical Services, selecting a service, and clicking 'Request This Service'. Our team will review and coordinate with the hospital.",
  "Generally you'll need a valid passport, medical records (if applicable), and visa documentation. We'll provide a detailed checklist after your request is reviewed.":
    "Generally you'll need a valid passport, medical records (if applicable), and visa documentation. We'll provide a detailed checklist after your request is reviewed.",
  "Initial review: 1-3 business days. Hospital coordination: 3-7 business days. Complex cases may take longer.":
    "Initial review: 1-3 business days. Hospital coordination: 3-7 business days. Complex cases may take longer.",
  "Yes. All medical information is encrypted and stored securely. We comply with international data protection standards.":
    "Yes. All medical information is encrypted and stored securely. We comply with international data protection standards.",

  // Demo data notices
  "DEMO DATA": "DEMO DATA",
  "Demo data notice":
    "Demo environment — hospitals, doctors, ratings and prices are fictional or unverified demo data. No real medical partnership, appointment or medical advice.",
  "Demo hospital notice":
    "Demo data — fictional or unverified hospital listing. No real partnership, accreditation, rating or medical capability is claimed.",
  "Demo doctor notice":
    "Demo profile — fictional doctor name and credentials. No real physician, licence or hospital affiliation is claimed.",
  "Demo price notice":
    "Prices are example estimates only, not hospital quotes or binding offers. Final costs require hospital confirmation.",
  "Demo booking notice":
    "Demo requests are stored in the shared demo database. Status updates are simulated and never create a real hospital appointment.",
  "Demo travel notice":
    "Demo travel assistance request only. No real transfer, hotel, interpreter or escort is booked.",
  "Demo concierge notice":
    "Automated demo assistant. Not a real human concierge and not medical advice.",
  "Example Estimate": "Example Estimate",
  "Demo mode · simulated replies": "Demo mode · simulated replies",
};

// Chinese dictionary — translations from preview HTML plus additional keys
export const zh: Record<string, string> = {
  // Brand
  "ChinaCare+": "ChinaCare+",
  "Medical Care in China": "在华医疗服务",

  // Header menu
  "Medical Services": "医疗服务",
  "Hospitals": "医院",
  "Doctors": "医生",
  "Book a Service": "预约服务",
  "Travel Assistance": "旅行协助",
  "Help Center": "帮助中心",

  // Languages
  "English": "English",
  "简体中文": "简体中文",
  "繁體中文": "繁體中文",
  "日本語": "日本語",
  "한국어": "한국어",
  "Français": "Français",
  "Deutsch": "Deutsch",
  "Español": "Español",

  // BottomNav
  "Home": "首页",
  "Bookings": "我的预约",
  "Concierge": "医疗管家",
  "Me": "我的",

  // Banner
  "Trusted": "值得信赖的",
  "Medical Care": "医疗服务",
  "in China": "中国",
  "Checkup · Treatment · Surgery · Recovery": "体检 · 治疗 · 手术 · 康复",

  // SearchBar
  "Search hospitals, treatments or services": "搜索医院、治疗或服务",

  // Service categories
  "Health Checkup": "健康体检",
  "Medical Treatment": "疾病治疗",
  "Surgery Services": "手术服务",
  "Recovery & Rehabilitation": "康复治疗",

  // Concierge banner
  "Your Medical Concierge in China": "您的中国医疗管家",
  "From consultation to recovery, we are with you every step.": "从咨询到康复，全程贴心陪伴。",
  "Chat with Concierge": "联系医疗管家",

  // Hospitals section (home)
  "Recommended Hospitals": "推荐医院",
  "View All": "查看全部",
  "Top Hospital": "顶级医院",
  "Remove from favorites": "取消收藏",
  "Add to favorites": "添加收藏",
  "reviews": "评价",

  // How It Works
  "How It Works": "服务流程",
  "Submit Your Request": "提交您的申请",
  "Medical Assessment": "医疗评估",
  "Come to China": "来中国",
  "Treatment & Follow-up": "治疗与随访",

  // Why Choose China
  "Why Choose China?": "为什么选择中国？",
  "World-class Hospitals": "世界级医院",
  "Experienced Specialists": "资深专家团队",
  "Advanced Medical Technology": "先进医疗技术",
  "High-Value Care": "高价值医疗",

  // Hospitals page
  "Top-ranked medical centres across China": "全国顶尖医疗中心",
  "Search hospitals or specialties...": "搜索医院或科室...",
  "City": "城市",
  "Specialty": "科室",
  "No hospitals found": "未找到医院",
  "Try another city, specialty or keyword.": "请尝试其他城市、科室或关键词。",

  // Doctors page
  "Our Doctors": "我们的医生",
  "English-speaking specialists vetted for international care": "精选国际医疗英语专家",
  "Search doctors or specialties...": "搜索医生或科室...",
  "No doctors found": "未找到医生",
  "Try a different name or specialty.": "请尝试其他名字或科室。",
  "yrs exp": "年经验",

  // Services page
  "Specialist care across checkup, treatment, surgery and recovery": "涵盖体检、治疗、手术与康复的专科医疗服务",
  "Search services...": "搜索服务...",
  "All": "全部",
  "No services found": "未找到服务",
  "Try a different keyword or choose another care category.": "请尝试其他关键词或选择其他医疗类别。",
  "Request This Service": "预约此服务",

  // Book page
  "Submit your medical service request": "提交您的医疗服务申请",
  "Full Name *": "姓名 *",
  "Enter your full name": "请输入您的姓名",
  "Email Address *": "邮箱地址 *",
  "Country / Region *": "国家 / 地区 *",
  "Your country": "您所在的国家",
  "Preferred City": "意向城市",
  "Any city": "任意城市",
  "Medical Service *": "医疗服务 *",
  "Select a service": "请选择服务",
  "Preferred Date *": "意向日期 *",
  "Preferred Language": "偏好语言",
  "Contact Preference": "联系方式偏好",
  "Medical Records (Optional)": "病历资料（可选）",
  "Tap to upload your records": "点击上传您的病历资料",
  "Additional Requirements": "其他需求",
  "Describe your medical needs, conditions, or special requirements...": "请描述您的医疗需求、病情或特殊要求...",
  "Records can also be shared securely with your concierge after booking.": "预约后也可将病历安全共享给您的管家。",
  "Submit Request": "提交申请",
  "Submitting...": "提交中...",
  "Full name is required": "请填写姓名",
  "Email is required": "请填写邮箱",
  "Invalid email format": "邮箱格式不正确",
  "Country is required": "请填写国家",
  "Please select a service": "请选择服务",
  "Preferred date is required": "请选择意向日期",
  "Request Submitted": "申请已提交",
  "Your booking reference:": "您的预约编号：",
  "View My Bookings": "查看我的预约",
  "Back to Home": "返回首页",

  // Booking status note
  "This is a service request, not a confirmed appointment. Our team will review your request and coordinate with the hospital. You will receive a status update within 1–3 business days.":
    "此为服务申请，非已确认预约。我们的团队将审核您的申请并与医院协调，您将在 1-3 个工作日内收到状态更新。",

  // Languages dropdown (book form)
  "Chinese": "中文",
  "Japanese": "日语",
  "Korean": "韩语",
  "Spanish": "西班牙语",
  "French": "法语",
  "German": "德语",
  "Russian": "俄语",
  "Arabic": "阿拉伯语",
  "Other": "其他",

  // Contact prefs
  "Email": "邮箱",
  "Phone": "电话",
  "WhatsApp": "WhatsApp",
  "WeChat": "微信",

  // Booking status labels
  "Pending": "待处理",
  "Under Review": "审核中",
  "Coordinating": "协调中",
  "Confirmed": "已确认",
  "Completed": "已完成",
  "Cancelled": "已取消",

  // Booking status notes
  "Your request is being reviewed by our medical team.": "您的申请正在由我们的医疗团队审核中。",
  "We are coordinating with the hospital for your appointment.": "我们正在与医院协调您的预约安排。",
  "Your treatment has been completed. Follow-up scheduled.": "您的治疗已完成，后续随访已安排。",
  "Your request has been submitted and is awaiting review.": "您的申请已提交，正在等待审核。",

  // Bookings page
  "My Bookings": "我的预约",
  "Track your service requests": "跟踪您的服务申请",
  "No bookings yet": "暂无预约记录",
  "Submit a request and our team will coordinate your care.": "提交申请，我们的团队将为您协调医疗服务。",
  "Submitted": "提交于",

  // Concierge page
  "Medical Concierge": "医疗管家",
  "Welcome to ChinaCare+ Medical Concierge! How can I help you today?": "欢迎使用 ChinaCare+ 医疗管家！请问有什么可以帮您？",
  "Online · Typically replies in 1 hour": "在线 · 通常 1 小时内回复",
  "How do I book a service?": "如何预约服务？",
  "What documents do I need?": "我需要准备哪些文件？",
  "How long does the process take?": "整个流程需要多长时间？",
  "Is my data secure?": "我的数据安全吗？",
  "Thank you for your message. A concierge specialist will respond within 1 business hour. For urgent matters, please call +86-400-123-4567.":
    "感谢您的留言。管家专员将在 1 个工作小时内回复您。如需紧急处理，请致电 +86-400-123-4567。",
  "Type your question...": "请输入您的问题...",
  "Message your concierge": "向管家发送消息",
  "Send message": "发送消息",
  "Concierge responses are informational and do not replace medical advice.": "管家回复仅供参考，不能替代医疗建议。",

  // Me page
  "My Profile": "我的账户",
  "Your account and care services": "您的账户与医疗服务",
  "Sign In": "登录",
  "Access your profile and bookings": "查看您的账户信息与预约记录",
  "Account Settings": "账户设置",
  "Coming soon": "即将上线",
  "Sign Out": "退出登录",
  "Password": "密码",
  "Enter password": "请输入密码",
  "Member since": "会员自",
  "ChinaCare+ coordinates medical services and does not provide diagnosis or treatment directly.": "ChinaCare+ 协调医疗服务，不直接提供诊断或治疗。",

  // Help page
  "Find answers to common questions about your care journey": "寻找关于您医疗旅程的常见问题解答",
  "General": "通用问题",
  "Booking": "预约相关",
  "Payment": "支付相关",
  "Travel": "旅行相关",
  "Privacy": "隐私相关",
  "No FAQs in this category": "该分类下暂无常见问题",
  "Try another topic or chat with our concierge team.": "请尝试其他话题或联系我们的医疗管家。",
  "Still need help?": "还需要帮助？",
  "Get help from our medical coordinators": "联系我们的医疗协调专员",
  "Call Us": "拨打电话",
  "Policies": "政策法规",
  "Cancellation Policy": "取消政策",
  "Free cancellation before “Confirmed” status. After confirmation, hospital cancellation terms apply. Contact your concierge for assistance with cancellations.":
    "在「已确认」状态之前可免费取消。确认后，取消条款以医院规定为准。如需帮助请联系您的医疗管家。",
  "Privacy Policy": "隐私政策",
  "Your medical data is encrypted and never shared without explicit consent. We comply with international data protection standards. Request data deletion at any time.":
    "您的医疗数据经过加密，未经明确同意绝不会共享。我们符合国际数据保护标准。您可随时申请删除数据。",

  // FAQ
  "How does ChinaCare+ work?": "ChinaCare+ 是如何运作的？",
  "ChinaCare+ connects international patients with top hospitals in China. Submit your medical needs, our team coordinates with hospitals, and we guide you through every step from consultation to recovery.":
    "ChinaCare+ 为国际患者连接中国顶级医院。提交您的医疗需求，我们的团队与医院协调，全程陪伴从咨询到康复的每一步。",
  "Is ChinaCare+ a hospital?": "ChinaCare+ 是一家医院吗？",
  "No. ChinaCare+ is a medical consultation and service coordination platform. We do not provide medical diagnosis, prescribe medication, or deliver treatment directly. We connect you with accredited hospitals and specialists.":
    "不是。ChinaCare+ 是医疗咨询与服务协调平台。我们不直接提供医疗诊断、开药或治疗，而是为您连接有资质的医院和专家。",
  "How long does the booking process take?": "预约流程需要多长时间？",
  "Initial review takes 1–3 business days. Hospital coordination typically takes 3–7 business days. Complex cases may require additional time for multidisciplinary review.":
    "初步审核需要 1-3 个工作日。医院协调通常需要 3-7 个工作日。复杂病例可能需要额外的多学科会诊时间。",
  "Can I cancel my booking?": "我可以取消预约吗？",
  "You can cancel your request before it reaches 'Confirmed' status at no charge. After confirmation, cancellation policies depend on the hospital's terms. Contact your concierge for assistance.":
    "在预约状态变为「已确认」之前可免费取消。确认后，取消政策取决于医院规定。如需帮助请联系您的医疗管家。",
  "How do I pay for medical services?": "医疗服务如何支付？",
  "Medical service fees are paid directly to the hospital. ChinaCare+ service fees are billed separately. We accept international credit cards and bank transfers. Detailed pricing is provided before confirmation.":
    "医疗服务费直接支付给医院。ChinaCare+ 服务费单独结算。我们接受国际信用卡和银行转账。确认前会提供详细价格。",
  "Do you help with visa applications?": "你们协助签证申请吗？",
  "We provide invitation letters from partner hospitals to support your medical visa application. Visa processing is handled by the Chinese embassy or consulate in your country.":
    "我们提供合作医院的邀请函以支持您的医疗签证申请。签证办理由您所在国家的中国大使馆或领事馆负责。",
  "How is my medical data protected?": "我的医疗数据如何保护？",
  "All medical information is encrypted and stored securely. We comply with international data protection standards. Your data is only shared with hospitals you explicitly authorize.":
    "所有医疗信息均经过加密并安全存储。我们符合国际数据保护标准。您的数据仅会在您明确授权的情况下分享给医院。",
  "What is your privacy policy?": "你们的隐私政策是什么？",
  "We collect only necessary information to coordinate your care. Data is never sold to third parties. You can request data deletion at any time. Full policy available in our Help Center.":
    "我们仅收集协调医疗所需的必要信息。数据绝不会出售给第三方。您可随时申请删除数据。完整政策请查看帮助中心。",

  // Travel page
  "Support services for your medical journey": "为您的医疗之旅提供支持服务",
  "Medical Translation": "医疗翻译",
  "Professional medical interpreters for consultations and procedures.": "提供咨询和治疗过程中的专业医疗口译服务。",
  "Hospital Escort": "医院陪诊",
  "Dedicated companion to guide you through hospital visits.": "专人陪同，带您顺利完成医院就诊。",
  "Accommodation Arrangement": "住宿安排",
  "Comfortable lodging near your treatment hospital.": "治疗医院附近的舒适住宿。",
  "Airport Transfer & Transport": "机场接送与交通",
  "Reliable transportation throughout your medical journey.": "贯穿您医疗之旅的可靠交通服务。",
  "Travel assistance services are coordinated by our concierge team. Availability and pricing vary by location and season.":
    "旅行协助由我们的管家团队协调，具体服务与价格因地点和季节而异。",

  // PageHeader
  "Back": "返回",

  // Services detail page
  "Service Details": "服务详情",
  "Service not found": "未找到服务",
  "This service may no longer be available.": "此服务可能已不可用。",
  "What's Included": "服务包含",
  "Price Range": "价格范围",
  "Duration": "时长",
  "Prices are estimates only. Final pricing is confirmed by the hospital after medical assessment. ChinaCare+ does not provide medical diagnosis or treatment directly.":
    "价格仅供参考，最终费用由医院在医疗评估后确认。ChinaCare+ 不直接提供医疗诊断或治疗。",

  // Hospitals detail page
  "Hospital Details": "医院详情",
  "Hospital not found": "未找到医院",
  "This hospital may no longer be listed.": "此医院可能已不再提供预约。",
  "Accreditation": "资质认证",
  "Departments": "科室",
  "Hospital information is for reference only. Availability and services are subject to hospital confirmation.":
    "医院信息仅供参考，具体服务与可预约情况以医院确认为准。",
  "Request Service at This Hospital": "在这家医院预约服务",

  // Doctors detail page
  "Doctor Details": "医生详情",
  "Doctor not found": "未找到医生",
  "This profile may no longer be available.": "此医生档案可能已不可用。",
  "About": "关于医生",
  "Experience": "从业经验",
  "Rating": "评分",
  "Specialties": "擅长科室",
  "Languages": "语言",
  "Doctor profiles are for reference. Availability is subject to hospital scheduling.":
    "医生档案仅供参考，实际可预约情况以医院排班为准。",
  "Request Appointment": "预约问诊",

  // Concierge FAQ responses (hardcoded answers)
  "You can book by going to Medical Services, selecting a service, and clicking 'Request This Service'. Our team will review and coordinate with the hospital.":
    "您可以前往「医疗服务」页面，选择服务后点击「预约此服务」。我们的团队将审核申请并与医院协调。",
  "Generally you'll need a valid passport, medical records (if applicable), and visa documentation. We'll provide a detailed checklist after your request is reviewed.":
    "通常需要有效的护照、病历资料（如有）以及签证文件。申请审核通过后我们会提供详细清单。",
  "Initial review: 1-3 business days. Hospital coordination: 3-7 business days. Complex cases may take longer.":
    "初步审核：1-3 个工作日。医院协调：3-7 个工作日。复杂病例可能需要更长时间。",
  "Yes. All medical information is encrypted and stored securely. We comply with international data protection standards.":
    "是的，所有医疗信息均加密存储。我们符合国际数据保护标准。",

  // Demo data notices
  "DEMO DATA": "演示数据",
  "Demo data notice":
    "演示环境 — 医院、医生、评分与价格均为虚构或未经核验的演示数据，不代表真实医疗合作、预约或医疗建议。",
  "Demo hospital notice":
    "演示数据 — 医院为虚构或未经核验的演示条目，不代表真实合作、认证、评分或医疗能力。",
  "Demo doctor notice":
    "演示资料 — 医生姓名与资历均为虚构，不代表真实执业医师、执照或医院任职关系。",
  "Demo price notice":
    "价格仅为示例估算，不构成医院报价或正式要约。最终费用须以医院确认为准。",
  "Demo booking notice":
    "演示申请保存在共享演示数据库中。状态更新均为模拟，不会产生真实医院预约。",
  "Demo travel notice":
    "仅为演示版来华配套服务申请，不会真实预订接送、酒店、翻译或陪诊服务。",
  "Demo concierge notice":
    "自动演示助手，并非真人在线服务，也不提供医疗诊断建议。",
  "Example Estimate": "示例估算",
  "Demo mode · simulated replies": "演示模式 · 模拟回复",
};
